import {
  BatchProcessingResponse,
  CADASTRO_PessoaDataType,
  EDICAO_PessoaDataType,
  FetchMembrosParamsDataType,
} from "@/types/membros"
import api, { api_v2 } from "@/api/axios.config"

interface UserPayloadTypes {
  user: CADASTRO_PessoaDataType
  emp_id: number
  pessoa_id?: number
  originador_id: number
}

export const fetchMembrosAction = async (params?: FetchMembrosParamsDataType) => {
  const queryString = new URLSearchParams(params as Record<string, string>).toString()

  return api_v2.get(`/membros${queryString ? `?${queryString}` : ""}`)
}

export const getAllMemberStates = async () => {
  return api_v2.get("/membros/estados")
}

export const getMemberCategories = async () => {
  return api_v2.get("/membros/categorias-app")
}

export const getMemberSubcategories = async (categoriaId: number) => {
  return api_v2.get(`/membros/subcategorias-app?categoria=${categoriaId}`)
}

export const getMemberById = async (id: string) => {
  return api_v2.get(`/membros/${id}/detalhes`)
}

export const createUser = async ({ user, emp_id, originador_id }: UserPayloadTypes) => {
  return api.post("/plataforma/pessoas", { ...user, emp_id, originador_id })
}

export const updateUser = async (payload: EDICAO_PessoaDataType) => {
  return api_v2.post("/plataforma/alterar-pessoa", payload, {
    headers: {
      "no-cache": "true",
      pragma: "no-cache",
      expires: "0",
    },
  })
}

export const createBatchUsers = async (payload: FormData): Promise<BatchProcessingResponse> => {
  const { data } = await api.post<BatchProcessingResponse>(
    "/plataforma/importa-usuarios",
    payload,
    {
      headers: {
        "Content-Type": undefined,
      },
    }
  )

  return data
}

export const getFaceImage = async (): Promise<void> => {
  return api_v2.get("/credenciamento/person")
}

export const updateFaceImage = async (payload: FormData): Promise<void> => {
  return api_v2.post("/credenciamento/person", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export const checkFaceHikvision = async (payload: FormData): Promise<void> => {
  return api_v2.post("/credenciamento/person/check-face", payload)
}
